var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBatsmen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 153,
    viewBox: "0 0 167 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9856",
    "data-name": "Group 9856",
    transform: "translate(-784 -304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6049",
    "data-name": "Rectangle 6049",
    transform: "translate(784 304)",
    fill: "#fff",
    stroke: "#d4d4d4",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167,
    height: 153,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 165,
    height: 151,
    rx: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cricket-svgrepo-com_4_",
    "data-name": "cricket-svgrepo-com (4)",
    transform: "translate(832 332.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80146",
    "data-name": "Path 80146",
    d: "M271.033,23.716a1.858,1.858,0,1,0-1.858-1.858A1.86,1.86,0,0,0,271.033,23.716Z",
    transform: "translate(-224.839 -16.622)",
    fill: "#e85512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80147",
    "data-name": "Path 80147",
    d: "M277.565,27.07a6.3,6.3,0,0,0-3.038-2h-.006L254.3,45.286a1.924,1.924,0,0,0,0,2.717l2.329,2.329a1.921,1.921,0,0,0,2.718,0l20.22-20.219C279.6,29.761,279.059,28.565,277.565,27.07Z",
    transform: "translate(-212.011 -20.834)",
    fill: "#f19c7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80148",
    "data-name": "Path 80148",
    d: "M50.221,110.307a6.382,6.382,0,0,0,.372-3.285l-11.369,4.971a6.432,6.432,0,0,0,11-1.686Z",
    transform: "translate(-33.724 -88.947)",
    fill: "#ffd5a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80149",
    "data-name": "Path 80149",
    d: "M77.835,198.852c-.584-2.1-1.09-3.8-1.581-5.165l-6.668.519q-.067.005-.133.005a1.689,1.689,0,0,1-.129-3.373l5.359-.417a3.668,3.668,0,0,0-3.277-1.653,11.762,11.762,0,0,0-3.092.5c-3.8,1.055-4.55,2.417-4.794,3.733-.383,2.066.414,5.192,1.582,9.384,2.134,7.69,4.132,9.235,6.663,9.235a9.922,9.922,0,0,0,2.645-.423C78.9,209.947,80.37,207.954,77.835,198.852Z",
    transform: "translate(-53.835 -156.888)",
    fill: "#eaf2df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80150",
    "data-name": "Path 80150",
    d: "M31.244,78.6a6.4,6.4,0,0,0-.379,3.278L42.236,76.9A6.427,6.427,0,0,0,31.244,78.6Z",
    transform: "translate(-26.719 -61.924)",
    fill: "#eaf2df"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80151",
    "data-name": "Path 80151",
    d: "M254.411,10.471a5.236,5.236,0,1,0-5.236-5.236A5.241,5.241,0,0,0,254.411,10.471Zm0-7.093a1.858,1.858,0,1,1-1.858,1.858A1.86,1.86,0,0,1,254.411,3.378Z",
    transform: "translate(-208.216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80152",
    "data-name": "Path 80152",
    d: "M76.978,11.2A13.3,13.3,0,0,0,74.6,8.06C73.233,6.7,71.183,5.069,69.171,5.069a3.292,3.292,0,0,0-2.378.973L46.559,26.276a5.306,5.306,0,0,0-.029,7.464l-2.74,2.74-12.55.976c-1.45-2.859-3.492-4.74-7.014-4.74a15.01,15.01,0,0,0-4,.627c-2.729.757-6.445,2.242-7.211,6.372-.515,2.78.358,6.274,1.648,10.9,1.95,7.027,4.383,11.708,9.917,11.708.07,0,.141,0,.212,0a6.585,6.585,0,0,1-1.941,7.55c-2.224,1.918-6.308,3-10.5-.278a1.689,1.689,0,0,0-2.475.44L6.91,74.818A1.689,1.689,0,1,0,9.779,76.6l2.039-3.284a11.206,11.206,0,0,0,13.242-.885A9.914,9.914,0,0,0,28.18,61.769a11.771,11.771,0,0,0,4.288-2.07c3.761-1.021,7.182.11,9.2,3.058,1.8,2.64,2.643,7.344-.926,11.912A1.689,1.689,0,0,0,42.068,77.4H47.7a1.689,1.689,0,0,0,0-3.378H45.12a13.908,13.908,0,0,0,1.451-5.566,12.586,12.586,0,0,0-2.119-7.6A11.1,11.1,0,0,0,34.9,55.96c.768-2.791.21-6.384-.988-10.687-.439-1.583-.866-3.114-1.34-4.532l7.546-.587-.075.075a1.689,1.689,0,1,0,2.388,2.389l6.488-6.488a5.3,5.3,0,0,0,7.464-.029L76.615,15.865C77.289,15.191,78.231,13.69,76.978,11.2ZM24.584,58.95c-2.531,0-4.528-1.545-6.663-9.235-1.168-4.192-1.965-7.318-1.582-9.384.244-1.315.993-2.678,4.794-3.733a11.755,11.755,0,0,1,3.092-.5A3.668,3.668,0,0,1,27.5,37.746l-5.359.417a1.689,1.689,0,0,0,.129,3.373c.044,0,.088,0,.133-.005l6.668-.519c.491,1.364,1,3.062,1.581,5.165,2.535,9.1,1.066,11.095-3.426,12.35A9.933,9.933,0,0,1,24.584,58.95Zm28.05-24.677a1.909,1.909,0,0,1-1.359-.563l-2.329-2.329a1.924,1.924,0,0,1,0-2.717L69.165,8.447h.006a6.3,6.3,0,0,1,3.038,2c1.495,1.495,2.032,2.691,2,3.042L53.993,33.71A1.908,1.908,0,0,1,52.634,34.273Z",
    transform: "translate(-6.656 -4.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80153",
    "data-name": "Path 80153",
    d: "M11.61,68.236a9.806,9.806,0,0,0,18.514-6.252l4.779-2.09A1.689,1.689,0,1,0,33.549,56.8l-4.778,2.089A9.809,9.809,0,0,0,11.61,68.236Zm11.333-9.912A6.4,6.4,0,0,1,25.6,60.273L14.234,65.246a6.423,6.423,0,0,1,8.709-6.921ZM15.589,68.339l11.369-4.971a6.43,6.43,0,0,1-11.369,4.971Z",
    transform: "translate(-10.088 -45.294)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatsmen);
export default __webpack_public_path__ + "static/media/batsmen.30cf07d8d05ecfd156d0971cc06368fb.svg";
export { ForwardRef as ReactComponent };